import React, { useEffect } from 'react'

import { useTranslations } from '../../hooks/use-translations'
import ModalCookieConsent from '../Common/ModalCookieConsent'
import { AppRegionEnum } from '../../types/app-region.enum'
import { GlobalContext } from '../../context/GlobalContext'
import { updateConsent } from './helpers'

const CookieConsent: React.FC = () => {
  const [showModal, setShowModal] = React.useState(false)
  const { region } = React.useContext(GlobalContext)
  const regionConsent = region === AppRegionEnum.Us
  const { t, getPath } = useTranslations()

  useEffect(() => {
    const prodHosts = ['signax.io', 'sgnl.pro']
    const consentGiven = localStorage.getItem('cookieConsent')

    if (
      typeof window !== 'undefined' &&
      prodHosts.includes(window.location.hostname)
    ) {
      if (!window.dataLayer) {
        window.dataLayer = []
      }
      if (regionConsent && !consentGiven) {
        setShowModal(true)
      } else {
        updateConsent()
      }
    }
  }, [regionConsent])

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true')
    updateConsent()
    setShowModal(false)
  }

  if (!showModal) return null

  return (
    <ModalCookieConsent
      onAccept={handleAccept}
      consentText={t('Consent text')}
      buttonText={t('I agree')}
      linkText={t('Privacy link')}
      linkTo={getPath('/privacy')}
    />
  )
}

export default CookieConsent
